import createInboxRuleFromStoreEditState from './helpers/createInboxRuleFromStoreEditState';
import newInboxRuleAction from './newInboxRuleAction';
import setInboxRuleAction from './setInboxRuleAction';
import { InboxRulesOptionState } from '../store/schema/InboxRulesOptionState';
import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
import resetInboxRuleEdit from './resetInboxRuleEdit';
import getInboxRules from './getInboxRules';

export interface SaveInboxRuleEditStoreState {
    optionState: InboxRulesOptionState;
}

export default action('saveInboxRuleEdit')(
    select<SaveInboxRuleEditStoreState>({
        optionState: () => store,
    })(async function saveInboxRuleEdit(state?: SaveInboxRuleEditStoreState): Promise<void> {
        let inboxRuleId = state.optionState.inboxRulesEditState.ruleId;
        let inboxRule = createInboxRuleFromStoreEditState(inboxRuleId);

        // If the rule already has an id, that means it is an edited rule
        if (inboxRuleId) {
            return setInboxRuleAction(inboxRule, store.inboxRulesEditState.shouldRunRuleNow);
        } else {
            // no-op if the user is saving an unmodified rule
            return newInboxRuleAction(
                inboxRule,
                'RuleOption',
                onSaveSuccess,
                () => Promise.resolve(),
                store.inboxRulesEditState.shouldRunRuleNow
            );
        }
    })
);

function onSaveSuccess() {
    resetInboxRuleEdit();
    // re-fetch the rules list if successful
    getInboxRules();
    return Promise.resolve();
}
